import { action, atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { isInitializationReadyAtom } from '@root/features/initialization/atoms/common'
import { STORAGE_PREFIX } from '@root/shared'

const TAB_STORAGE_KEY = `${STORAGE_PREFIX}/v1/instantTradeDialogTab`
const POSITION_STORAGE_KEY = `${STORAGE_PREFIX}/v1/instantTradeDialogPosition`
const INSTANT_TRADE_VARIANT_STORAGE_KEY = `${STORAGE_PREFIX}/v1/instantTrade/variant`
const INSTANT_TRADE_VISIBLE_STORAGE_KEY = `${STORAGE_PREFIX}/v1/instantTrade/visible`

export const instantTradeDialogVisibleAtom = atom<boolean>(
  false,
  'instantTradeDialogVisibleAtom',
).pipe(withLocalStorage(INSTANT_TRADE_VISIBLE_STORAGE_KEY))

export type InstantTradeTab = 'swap' | 'wallets' | 'settings'

export const openInstantTradeDialogAction = action(
  (ctx, tab: InstantTradeTab | undefined) => {
    instantTradeDialogVisibleAtom(ctx, true)
    if (tab) {
      instantTradeDialogTabAtom(ctx, tab)
    }
  },
  'openInstantTradeDialogAction',
)
export const closeInstantTradeDialogAction = action((ctx) => {
  instantTradeDialogVisibleAtom(ctx, false)
}, 'closeInstantTradeDialogAction')

export const toggleInstantTradeDialogAction = action((ctx) => {
  const isVisible = ctx.get(instantTradeDialogVisibleAtom)
  if (isVisible) {
    closeInstantTradeDialogAction(ctx)
    return
  }
  // Not open until the app knows who is here: the panel is somebody's
  // wallets and settings, and an empty one is worse than a closed one.
  if (!ctx.get(isInitializationReadyAtom)) {
    return
  }
  openInstantTradeDialogAction(ctx, 'swap')
}, 'toggleInstantTradeDialogAction')

export const instantTradeDialogTabAtom = atom<InstantTradeTab>(
  'swap',
  'instantTradeDialogTabAtom',
).pipe(withLocalStorage(TAB_STORAGE_KEY))
export type InstantTradeVariant = 'floating' | 'bottom'

export const instantTradeDialogVariantAtom = atom<InstantTradeVariant>(
  'floating',
  'instantTradeDialogVariantAtom',
).pipe(withLocalStorage(INSTANT_TRADE_VARIANT_STORAGE_KEY))

export const instantTradeDialogPositionAtom = atom<
  | {
      x: number
      y: number
    }
  | undefined
>(undefined, 'instantTradeDialogPositionAtom').pipe(
  withLocalStorage(POSITION_STORAGE_KEY),
)
